function cylindoview(sku){
  let fullsku = sku
  let skusplit = sku.split("-")
  let reqsku = skusplit[0] + "-" +skusplit[1]
  let color = skusplit[skusplit.length-1]


  let url = "https://content-v2.cylindo.com/api/v2/5076/products/"+reqsku+"/frames/1/"+reqsku+".PNG?background=FFFFFF&feature=UPHOLSTERY:"+color
  // $("#colorpicker").remove()
  // $(".sp-replacer").remove()
  // $(".sp-container").remove()
  // $("#cylindo_image_parent").hide()
  // $(".cylindo_image_spin").remove()
  // $(".Product__Slideshow:eq(0)").show()
  // $(".Product__SlideshowNav").show()
  // $(".Product__SlideshowMobileNav").show()
  // $(".Product__ActionList").show()

  
  $.ajax({
    type: "get",
    url: url,
    success: function (response) {
        if (response){
          $(".Product__Slideshow:eq(0)").hide()
          $(".Product__SlideshowNav").hide()
          $(".Product__SlideshowMobileNav").hide()
          $(".Product__ActionList").hide()
          $("#cylindo_image_parent").show()

          $(".cylindo_image_spin").remove()
          let bortherheight = $(window).width()<830?$(window).width():830
          if ($("#cylindo_image_parent").length == 0) {
            $(".Product__Slideshow:eq(0)").before(`<div id="cylindo_image_parent" style="overflow:hidden;height:${parseInt(bortherheight*0.8)}px;"><div id="cylindo_image_content"></div></div>`)
            // $("#cylindo_image_parent").css("height", String(parseInt(bortherheight*0.8)));
            // $("#cylindo_image_content").css("transform","translateY(-20%)")
          }else{
            $("#cylindo_image_content").remove()
            $("#cylindo_image_parent").append(`<div id="cylindo_image_content"></div>`)
          }

          var viewerInstance = null;
          // the opts object should hold the start properties of the 360 HD Viewer
          var opts = {  
            'accountID': 5076,
            'SKU': reqsku,
            'features': ["UPHOLSTERY",color],
            'country': 'ca',
            'containerID': 'cylindo_image_content',
            'thumbs' : true,
            'thumbCount': 5,
            'thumbAngles': [0,45,90,135,180],
            'thumbPageSize': 5,
            'fullscreen' : false,
            'size': parseInt(bortherheight),
            'productCode': 'EMMA_ARMCHAIR'
          }
          
          // make sure the cylindo framework has been "installed"
          if (cylindo) {
            // do not instantiate the viewer until the framework reports ready.
            cylindo.on('ready', function () {
              // create the instance
              viewerInstance = cylindo.viewer.create(opts);
            });
          }


          // $("#cylindo_image_parent").append(`<input type='text' id="colorpicker" value="#ffffff"/>`)
            
          // $("#colorpicker").spectrum({
          //     color: "#ffffff",
          //     showPalette: true,
          //     palette: ["#ffffff","#d4d5cf","#dfcfd0","#fefaee","#f1ece6","#dadbd9","#faecde","#d9cbb0","#c5b8a5","#b6b2a5","#a29b89","#965657","#695356","#a3807e","#ead3d5","#000000","#c3cdd6","#b0b2b2","#8797a6","#9da9b7","#919690","#c0c0c0","#ececea","#fefdf9","#e1e6e0","#b7c6b1","#97a38b","#7e8c73","#dfd7d8","#656565"],
          //   showInput:true,  
          //   change: function(color) {
          //      cylindobgchang(color.toHexString())
          //     }
          // })
          // $(".sp-replacer").css("position","absolute")
          // $(".sp-replacer").css("top","10px")
          // $(".sp-replacer").css("left","10px")
          
          $(".Product__SlideshowNav .Product__SlideshowNavScroller .Product__SlideshowNavImage").removeClass("is-selected")
          $(".Product__SlideshowMobileNav .flickity-page-dots .dot").removeClass("is-selected")
          $(".Product__SlideshowNav .Product__SlideshowNavScroller").append(`<div class="cylindo_image_spin Product__SlideshowNavImage AspectRatio is-selected" style="--aspect-ratio: 1.9246987951807228;">
                <img src="//cdn.shopify.com/s/files/1/0591/0786/8881/files/360-spin-logo.png?v=1675839104"></div>`)
          $(".Product__SlideshowMobileNav .flickity-page-dots").append(`<button type="button" aria-label="Show image cylindo" class="dot is-selected cylindo_image_spin"></button>`)
          $(".Product__SlideshowNav .Product__SlideshowNavScroller .Product__SlideshowNavImage").click(function (e) { 
            e.preventDefault();
            if ($(this).hasClass("cylindo_image_spin")){
              $(".Product__Slideshow:eq(0)").hide();
              $(".Product__SlideshowNav .Product__SlideshowNavScroller .Product__SlideshowNavImage").removeClass("is-selected");
              $("#cylindo_image_parent").show();
              $(this).addClass("is-selected");
            }else{
              $(".cylindo_image_spin").removeClass("is-selected");
              $("#cylindo_image_parent").hide();
              $(".Product__Slideshow:eq(0)").show();
            }
          });
          $(".Product__SlideshowMobileNav .flickity-page-dots .dot").click(function (e) { 
            e.preventDefault();
            if ($(this).hasClass("cylindo_image_spin")){
              $(".Product__Slideshow:eq(0)").hide();
              $(".Product__SlideshowMobileNav .flickity-page-dots .dot").removeClass("is-selected");
              $("#cylindo_image_parent").show();
              $(this).addClass("is-selected");
            }else{
              $(".cylindo_image_spin").removeClass("is-selected");
              $("#cylindo_image_parent").hide();
              $(".Product__Slideshow:eq(0)").show();
            }
          });
              
        }
    },
    error: function (e){
      // $("#colorpicker").remove()
      // $(".sp-replacer").remove()
      // $(".sp-container").remove()
      $("#cylindo_image_parent").hide()
      $(".cylindo_image_spin").remove()
      $(".Product__Slideshow:eq(0)").show()
      let currentscreenwidth = $(window).width()
      if (currentscreenwidth < 1008) {
        $(".Product__SlideshowNav").hide()
      }else{
        $(".Product__SlideshowNav").show()
      }
      // $(".Product__SlideshowNav").show()
      $(".Product__SlideshowMobileNav").show()
      $(".Product__ActionList").show()
    }
});
}

function cylindobgchang(hexcolor){
  hexcolor = hexcolor.slice(1).toUpperCase()
  let cylindocontainer = $(".cylindo-viewer-container img")
  for (let i = 0; i < cylindocontainer.length; i++) {
    const element = cylindocontainer[i]
    let replacesrc = element.src.split("?")[1].split("&")[0]
    element.src = element.src.replace(replacesrc,"background="+hexcolor)
  }
}